import React from "react";
import { Link } from "react-router-dom";

const Detailpart1 = ({ caseData }) => {
  if (!caseData) {
    return <div>Loading case details...</div>;
  }

  return (
    <div className="detailspart">
      <div className="case-hero">
        <div className="case-hero__top">
          <Link className="case-hero__back" to="/case-studies">
            ← Back to case studies
          </Link>
        </div>

        <div className="case-hero__grid">
          <div className="case-hero__content">
            <h1>{caseData.title}</h1>
            <p className="parasubtittle">{caseData.subtitle}</p>

            <div className="case-hero__meta" aria-label="Case study metadata">
              {!!caseData.industry && (
                <span className="case-pill">Industry: {caseData.industry}</span>
              )}
              {!!caseData.tags?.length &&
                caseData.tags.map((tag) => (
                  <span key={tag} className="case-pill case-pill--tag">
                    {tag}
                  </span>
                ))}
            </div>
          </div>

          {!!caseData.img && (
            <div className="case-hero__media">
              <img
                src={caseData.img}
                alt={`${caseData.title} cover`}
                loading="lazy"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Detailpart1;
